declare const require: any;
import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  ElementRef,
  OnInit,
  ChangeDetectorRef,
} from "@angular/core";
import cloneDeep from "lodash-es/cloneDeep";
import { Subject, take, takeUntil } from "rxjs";
import { RouterService } from "src/app/libs/data-access/services/router/router.service";
import { PagesRoute } from "src/app/pages/src/app/ui/routes/routes.enum";
import { HotelsFacade } from "../../data-access/services/hotels.facade";
import { HomePageUtils } from "src/app/pages/home-page/src/app/ui/utils/home-page.utils";
import { DatePipe } from "@angular/common";
import { MatDialog } from "@angular/material/dialog";
import { ImageGalleryComponent } from "../image-gallery/image-gallery.component";
import { FormsMetadata } from "src/app/libs/ui/components/search-form/consts/form-metadata.const";
import { FindTripFormGroupInterface } from "src/app/libs/ui/components/search-form/interfaces/form-metadata.interface";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { CheckoutFacade } from "src/app/libs/data-access/services/checkout/services/checkout.facade";
import { HotelsPageUtil } from "../../data-access/utils/hotels-page.utils";
import { ViewGoogleMapComponent } from "../../ui/components/view-google-map/view-google-map.component";
declare var $: any;
@Component({
  selector: "tic-hotel-detail",
  templateUrl: "./hotel-detail.component.html",
  styleUrls: ["./hotel-detail.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HotelDetailComponent implements OnDestroy, OnInit{
  public selectedIndex: number = 0;
  hotel: any; //TODO: complete types
  hotelImages: any; //TODO: complete types
  hotelRooms: any;
  params: any;
  oppopup = false;
  private destroy$ = new Subject();
  uniqueRoomsCount:any=[];
  similarRoomCount:number=0;
  showPopup: boolean = false;
  showMapPopup: boolean = false;
  selectedRoomId: string = '';
  hotelCriteria: any;
  data: any;
  constructor(
    private routerService: RouterService,
    private dialog :MatDialog,
    private cdr: ChangeDetectorRef,
    private facadeCheckout: CheckoutFacade,
    public facade: HotelsFacade,
    private el: ElementRef,
    private sanitizer: DomSanitizer
  ) 
  {
    this.loadDataReload();
    this.loadedData();
  }

  ngOnInit(): void {
    this.getUniqueRoomCount();
  }

   getUniqueRoomCount(){
    if(this.hotel){
      this.uniqueRoomsCount=this.getSimilarRoomCounts(this.hotel);
    }
   }

   loadDataReload() {
    this.routerService
    .getUrlParams()
    .pipe(takeUntil(this.destroy$))
    .subscribe((res) => {
      //TODO: complete types
      this.params = res;
      this.data = HomePageUtils.finalizedObjectData(this.params);
      if (this.params.roomData != undefined ) {
        const base64Data = decodeURIComponent(this.params.roomData);
        const jsonString = atob(base64Data);
        const data = JSON.parse(jsonString);
        //this.facadeCheckout.setRoom(data);
      }
      if( this.data.destination != undefined ) {
        this.loadHotelCriteria(this.data);
      }
      
    });
    if( this.params['hotel_id'] ) {
      this.loadMapHotel();
    }
  }

  loadHotelCriteria(data: any) {
    const requestQueryHotels = HotelsPageUtil.getRequestQuery(data);
    this.hotelCriteria = requestQueryHotels.hotelsCriteria.criteria;
    this.hotelCriteria.checkIn =
      this.hotelCriteria.checkIn.date;
    this.hotelCriteria.checkOut =
    this.hotelCriteria.checkOut.date;
  }

  loadMapHotel() {
    // this.facadeCheckout.getPreSearchedHotel({
    //   criteria: this.hotelCriteria,
    //   hotelId: parseInt(this.params["hotel_id"])   
    // });
    const storedHotel = JSON.parse(localStorage.getItem('selectedHotel'));
    if(storedHotel) {
      this.facadeCheckout.setHotel(storedHotel);
    }
  }

  isTextOverflowing(text: string): boolean {
    // Logic to determine if the text overflows
    const element = document.createElement('span');
    element.textContent = text;
    element.style.visibility = 'hidden';
    element.style.position = 'absolute';
    document.body.appendChild(element);
    const isOverflowing = element.offsetWidth < element.scrollWidth;
    document.body.removeChild(element);
    return isOverflowing;
  }
  getSimilarRoomCounts(data:any):any {
    const roomCounts:any = {};
    const uniqueRooms:any = [];
    data.rooms.forEach((room:any) => {
      const roomCode = room.roomCode;
      roomCounts[roomCode] = (roomCounts[roomCode] || 0) + 1;
      if (!uniqueRooms.some((uniqueRoom:any) => uniqueRoom.roomCode === roomCode)) {
        const uniqueRoom = { ...room, count: roomCounts[roomCode] };
        uniqueRooms.push(uniqueRoom);
      }
    });
    return uniqueRooms;
  }
  private setHotelDetails(hotelId: number | string) {
    this.facade
      .getHotelById(hotelId)
      .pipe(take(1))
      .subscribe((data) => {
        if (data) {
          const roomsImages: any = [];
          const notRoomsImages: any = [];
          data.images.forEach((image: any) => {
            if (image.imgFacilityType === "Room") {
              roomsImages.push(image);
            } else {
              notRoomsImages.push(image);
            }
          });
          roomsImages.concat(notRoomsImages);

          this.hotelImages = this.organizeImages(roomsImages);
        } else {
          this.loadedData();
          // this.routerService.navigate(PagesRoute.HotelsPage);
        }

        this.hotel = this.setHotelsRooms(data);
      });
  }
  loadedData() {    
    this.facadeCheckout.hotel$.pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
      if( data && this.isObjectNotEmpty(data) ) {
        if (data) {
          const roomsImages: any = [];
          const notRoomsImages: any = [];
          data.images.forEach((image: any) => {
            if (image.imgFacilityType === "Room") {
              roomsImages.push(image);
            } else {
              notRoomsImages.push(image);
            }
          });
          roomsImages.concat(notRoomsImages);
          this.hotelImages = this.organizeImages(roomsImages);
          this.hotel = this.setHotelsRooms(data);
          this.getUniqueRoomCount();
      }
    }
    });

  }
  isObjectNotEmpty(obj: any): boolean {
    return obj && Object.keys(obj).length > 0;
  }
  private organizeImages(images: any): any[] {
    //TODO: complete types
    return images.map((image: any) => {
      const { url, roomCode, roomType} = image;
      return {
        image: url,
        thumbImage: url,
        roomCode,
        roomType
      };
    });
  }

  private setHotelsRooms(data: any): any {
    //TODO: complete types
    const copiedData = cloneDeep(data);
    copiedData.rooms.forEach((room: any) => {
      room["images"] = [];
      room.images = this.hotelImages.filter(
        (imageObject: any) => imageObject?.roomCode === room.roomCode
      );
    });
    return copiedData;
  }


  onSelectedRoom(): void {
    this.routerService.navigateAndAddHiddenParamsToUrl(
      {
        flightOfferId: this.params["flightOfferId"],
        flightOfferPrice: this.params["flightOfferPrice"],
      },
      false,
      PagesRoute.PaymentPage
    );
  }
  scrollTo(target: HTMLElement) {
    target.scrollIntoView({ behavior: "smooth" });
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
  openPopup() {
    this.oppopup = true;
    const dialog= this.dialog.open(ImageGalleryComponent,{width:"65%", height:"100vh", data:{images: this.hotel.images}})
  }
  
  closepopup() {
    this.oppopup = false;
  }

  ngAfterViewInit(): void {
  }
  
  onSubmitSearchForm(formDetails: FindTripFormGroupInterface): void {
    let copyFormDetails: any = { ...formDetails };
    const pipe = new DatePipe("en-US");
    copyFormDetails.inboundDate = pipe.transform(
      copyFormDetails.inboundDate,
      "yyyy-MM-dd"
    );
    copyFormDetails.outboundDate = pipe.transform(
      copyFormDetails.outboundDate,
      "yyyy-MM-dd"
    );
    copyFormDetails.destinationLocationCode =
      FormsMetadata.destination.optionsArray.find(
        (item) => item.displayName === formDetails.destinationLocationCode
      )?.value as string;
    copyFormDetails.originLocationCode = FormsMetadata.origin.optionsArray.find(
      (item) => item.displayName === formDetails.originLocationCode
    )?.value as string;
    if(copyFormDetails.paxesChildrenAges!=="null"){
      copyFormDetails.paxesChildrenAges = JSON.stringify(
        copyFormDetails.paxesChildrenAges
      );
    }
    
    const finalizedObject =HomePageUtils.finalizedObjectData(copyFormDetails);
    const finalizedObjectTemp =HomePageUtils.finalizedObjectDataTemp(copyFormDetails);
    let forwardRoute = PagesRoute.EventPage;
    this.routerService.navigateAndAddParamsToUrl(
      finalizedObjectTemp,
      true,
      forwardRoute
    );
  }

  showModal(selectedRoomId:string) {
    this.showPopup = true;
    this.selectedRoomId = selectedRoomId;
    this.cdr.detectChanges();
  }

  ClickedOut(event: Event) {
    const evt = event.target as HTMLButtonElement;
    if (evt.classList.contains("flight-popup")) {
      this.showPopup = false;
    }
  }

  closePopup() {
    this.showPopup = false;
  }

  showMapPopupHandler(){
      this.dialog.open(ViewGoogleMapComponent,{
        data: { hotel:this.hotel },
        width: '80vw',
    height: '80vh',
    panelClass: 'default-dialog'
      });
      return;
  }

  isSelectedHotelRoom(roomCode: any): boolean {
    let isSelected = false;  // Define a local flag to store the result
  let roomId=localStorage.getItem('selectedRoom');
    // Subscribe to the flight$ observable
    this.facadeCheckout.room$.pipe(takeUntil(this.destroy$)).subscribe((room:any) => {
      // Check if the flight exists in the array
      if(room && Object.keys(room).length === 0  && roomId){
        if (roomCode == roomId) {
          isSelected = true;
        }
      }else{
      if (roomCode == room?.roomCode ) {
        isSelected = true;
      }
    }
    });
  
    // Return the flag after the subscription completes
    return isSelected;
  }  
}
